__turbopack_context__.v({
  "fadeIn": "Hero-module__59nn_G__fadeIn",
  "fadeInUp": "Hero-module__59nn_G__fadeInUp",
  "heroButton": "Hero-module__59nn_G__heroButton",
  "heroImage": "Hero-module__59nn_G__heroImage",
  "heroImageBg": "Hero-module__59nn_G__heroImageBg",
  "heroSubtitle": "Hero-module__59nn_G__heroSubtitle",
  "heroTitle": "Hero-module__59nn_G__heroTitle",
  "heroTitleGradient": "Hero-module__59nn_G__heroTitleGradient",
  "heroTitleGradientBlueTeal": "Hero-module__59nn_G__heroTitleGradientBlueTeal",
});
